import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect, useRef } from 'react';
import { oryService } from './ory-service';
const OryContext = createContext(undefined);
export const OryProvider = ({ children }) => {
    const [session, setSession] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [flowError, setFlowError] = useState(null);
    const hasCheckedRef = useRef(false);
    const checkSession = async (force = false) => {
        // Skip if already checked (prevents double-check from StrictMode)
        if (hasCheckedRef.current && !force)
            return;
        hasCheckedRef.current = true;
        try {
            setIsLoading(true);
            const currentSession = await oryService.getCurrentSession();
            setSession(currentSession);
        }
        catch (error) {
            setSession(null);
        }
        finally {
            setIsLoading(false);
        }
    };
    const logout = async (returnTo) => {
        try {
            const logoutUrl = await oryService.logout(returnTo);
            window.location.href = logoutUrl;
        }
        catch (error) {
            setFlowError('Failed to logout. Please try again.');
        }
    };
    const clearError = () => {
        setFlowError(null);
    };
    // Check session on mount
    useEffect(() => {
        checkSession();
    }, []);
    // Periodically check session validity (every 5 minutes)
    useEffect(() => {
        const intervalId = setInterval(() => {
            checkSession(true);
        }, 5 * 60 * 1000); // 5 minutes
        return () => clearInterval(intervalId);
    }, []);
    const value = {
        session,
        identity: session?.identity || null,
        isAuthenticated: !!session?.active,
        isLoading,
        flowError,
        checkSession: () => checkSession(true),
        refetchSession: () => checkSession(true),
        logout,
        clearError,
    };
    return _jsx(OryContext.Provider, { value: value, children: children });
};
export const useOry = () => {
    const context = useContext(OryContext);
    if (!context) {
        throw new Error('useOry must be used within an OryProvider');
    }
    return context;
};
